export default __webpack_public_path__ + "static/media/dma3.dd13dbc8.csv";